import type {FC} from 'react';

import {useI18n} from '@yourcoach/i18n';

import {Text} from '../../../uikit/Text';
import * as S from './styles';

type PropsType = {
  duration: number;
};

export const ConferenceDuration: FC<PropsType> = ({duration}: PropsType) => {
  const {t} = useI18n();

  return (
    <S.Container>
      <S.DurationIcon />
      <Text color="text.gray" variant="label.la">
        {t('shared:duration')}
        {': '}
        <Text color="text.gray" variant="label.la" weight="bold">
          {t('shared:duration_min', {
            duration,
          })}
        </Text>
      </Text>
    </S.Container>
  );
};
